import React from 'react';
import PropTypes from 'prop-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
// Note: There is a cycle because the Step can render anything inside of it.
// eslint-disable-next-line import/no-cycle
import { renderOptionsDefault } from './helper';

import ContentfulRichTextWrapper from './index.style';

const ContentfulRichText = ({ richText, renderOptions }) => {
  if (!richText) {
    return null;
  }

  return (
    <ContentfulRichTextWrapper>
      {renderRichText(richText, renderOptions)}
    </ContentfulRichTextWrapper>
  );
};

ContentfulRichText.defaultProps = {
  renderOptions: renderOptionsDefault,
};
ContentfulRichText.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  richText: PropTypes.any.isRequired,
  renderOptions: PropTypes.shape({
    renderNode: PropTypes.shape({}),
  }),
};

export default ContentfulRichText;
